import {
  globalParameterConverter,
  industryTypeConverter,
  interconnectionConverter,
} from '@seu-converter';
import {
  SeuApiConverter,
  SeuIndustryTypeApi,
  SeuOffer,
  SeuOfferApi,
  SeuOfferDetails,
  SeuOfferDetailsApi,
} from '@seu-types';

export const offerConverter: SeuApiConverter<SeuOffer, SeuOfferApi> = {
  fromApi: (input) => {
    const offerDetails: SeuOfferDetails = offerDetailsConverter.fromApi(input);
    return {
      ...offerDetails,
      offerNumber: input.offerNumber,
      id: input.id,
      _key: input.offerNumber || input.id,
      createdBy: input.createdBy,
      createdAt: input.createdAt,
      globalParameters:
        input.globalParameterSets?.map((dto) => {
          return globalParameterConverter.fromApi(dto);
        }) ?? [],
      interconnections:
        input.interconnections?.map((dto) => {
          return interconnectionConverter.fromApi(dto);
        }) ?? [],
      defaultUnits: input.defaultUnits,
      opex: input.opex,
      emissionLimits: input.emissionLimits,
      updatedAt: input.updatedAt,
      editors: input.editors,
      currentEditor: input.currentEditor,
      isFavorite: input.isFavorite ?? false,
      isRevision: input.isRevision,
      originalOfferId: input.originalOfferId,
      revisionName: input.revisionName,
    };
  },
  toApi: () => {
    return {} as SeuOfferApi; // todo: implement
  },
};

export const offerDetailsConverter: SeuApiConverter<
  SeuOfferDetails,
  SeuOfferDetailsApi
> = {
  fromApi: (input) => {
    return {
      name: input.name,
      description: input.description,
      customer: input.customer,
      offerNumber: input.offerNumber,
      industries: [
        ...new Set(
          input.industries.map((industry) => {
            return industryTypeConverter.fromApi(industry);
          })
        ),
      ],
      address: input.streetName,
      address2: input.addressSupplement,
      zip: input.zipCode,
      city: input.location,
      countryCode: input.country,
    };
  },
  toApi: (input) => {
    return {
      name: input.name,
      offerNumber: input.offerNumber === '' ? null : input.offerNumber,
      description: input.description,
      customer: input.customer,
      industries: input.industries.map((industry) => {
        return industryTypeConverter.toApi
          ? industryTypeConverter.toApi(industry)
          : (industry.toUpperCase() as SeuIndustryTypeApi);
      }),
      streetName: input.address,
      addressSupplement: input.address2 ?? '',
      zipCode: input.zip,
      location: input.city,
      country: input.countryCode,
    };
  },
};
